module.exports = __webpack_public_path__ + "files/9cf28d629d970c4f7adcd4b278a7ddb2.png";